import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

/* eslint-disable-next-line */
export interface SurveyCompleteProps {}

export function SurveyComplete(props: SurveyCompleteProps) {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const friendlyCompanyId = pathname.split('/')[1];
  useEffect(() => {
    setTimeout(() => {
      navigate(`/${friendlyCompanyId}/form`, { replace: true });
    }, 5000);
  }, []);
  return (
    <div className="p-5 sm:p-0 flex flex-col justify-center">
      <h1 className="text-center m-auto text-4xl mb-5">
        {t('Thank you for submitting your responses!')}
      </h1>
    </div>
  );
}

export default SurveyComplete;
